export default __webpack_public_path__ + "static/media/radovan_s.baa9816d.jpg";